import { render, staticRenderFns } from "./OptionalEntryAttributes.vue?vue&type=template&id=0a3a2a04&scoped=true"
import script from "./OptionalEntryAttributes.vue?vue&type=script&lang=js"
export * from "./OptionalEntryAttributes.vue?vue&type=script&lang=js"
import style0 from "./OptionalEntryAttributes.vue?vue&type=style&index=0&id=0a3a2a04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3a2a04",
  null
  
)

export default component.exports